module.exports = __webpack_public_path__ + "assets/img/loginbg.b16e200c.png";